export enum PageType {
    Internal = 'internal',
    External = 'external',
}

export enum InternalFormField {
    RouterLink = 'routerLink',
    EditorContent = 'editorContent',
}